module.exports = __webpack_public_path__ + "static/media/sad.084d8a7e.png";